import { css } from '@emotion/react';
import { Gray, White } from '@constants/color';

export const container = css({
  width: 1920,
  height: 1080,
  display: 'flex',
  color: White.White10
});

export const leftSideContainer = css({
  width: 1152,
  height: 952,
  padding: 64
});

export const rightSideContainer = css({
  width: 512,
  backgroundColor: Gray.Gray90,
  padding: '0 64px',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  rowGap: 120
});
